import { IV3D } from '@/Interfaces/v3d';
import { lineDiameter, lineSegmentLength } from '@/Constants/3dConfig';

declare let v3d: IV3D;

const lineMaterial = new v3d.MeshStandardMaterial({ color: 0x393349 });
// const geometry = new v3d.SphereGeometry(1, 12, 6);
const geometry = new v3d.BoxGeometry(1, 1, 1);
const scale = 1;

export function getEdgeSphere() {
    const sphere  = new v3d.Mesh(geometry, lineMaterial);
    sphere.scale.set(scale*lineDiameter, scale*lineDiameter, scale*lineDiameter);
    return sphere;
}
